import { DashboardMenuItem } from '@app/components/Routes/DashboardMenu';

const getAccessibleMenu = (
	checkUserAccess: (roles: Array<number>, props?: any) => boolean,
	rootCheckAdminMenu: Array<DashboardMenuItem>,
	checkFeaturesAccess: (value: DashboardMenuItem) => boolean,
	canAccess: (path: string) => boolean,
) => {
	return rootCheckAdminMenu.reduce((acc: Array<DashboardMenuItem>, value: DashboardMenuItem) => {
		let current = value;
		let shouldBeShown = value.path !== ''
			? canAccess(value.path)
			: (!value.roles?.length || checkUserAccess(value.roles)) && checkFeaturesAccess(value);

		if (value.children) {
			current = JSON.parse(JSON.stringify(value));
			current.children!.list = current.children!.list.filter((el) => checkFeaturesAccess(el)
				&& (el.path !== ''
					? canAccess(el.path)
					: (!value.roles?.length || checkUserAccess(value.roles)) && checkFeaturesAccess(value)
				));

			shouldBeShown = shouldBeShown && current.children!.list.length > 0;
		}

		return shouldBeShown ? [...acc, current] : [...acc];
	}, []);
};

export default getAccessibleMenu;
